import styled from 'styled-components';
import { Collapse } from 'antd';

export const Accordion = styled(Collapse)`
  width: 100%;
  border: 0!important;
  >.ant-collapse-item-active{
    background-color: #f2f2f2;
    box-shadow: 0px 0px 5px 0px	rgba(52, 52, 52, 0.3);

    >.ant-collapse-header{
      background: #FFF!important;
      color: #000!important;
    }
  }
  >.ant-collapse-item {
    border-radius: 0;
    margin-bottom: 20px!important;
    .ant-collapse-header {
      position: relative;
    background: #000;
    color: #FFF;
      /* padding: 12px 16px 12px 40px;
      cursor: pointer;
      transition: all 0.3s; */
      /* background: ${({ isOpen }) => (isOpen ? '#FFF' : '#000')};
      color: ${({ isOpen }) => (isOpen ? '#000' : '#FFF')}; */
      border-radius: 0;
    }
  }
  .ant-collapse-item:last-child, 
  .ant-collapse-item:last-child > .ant-collapse-header {
      border-radius: 0!important;
  }
  .ant-collapse-content{
    .ant-collapse-content-box{
      background-color: #f2f2f2;
	    box-shadow: 0px 0px 5px 0px rgba(52, 52, 52, 0.3);
    }
  }
`;
export const AccordionSub = styled(Collapse)`
  width: 100%;
  border: 0!important;
  
  .ant-collapse-item {
    border:0!important;
    .ant-collapse-header {
      position: relative;
      font-size:14px;
      padding: 12px 16px 12px 40px;
      color: #000;
      cursor: pointer;
      transition: all 0.3s;
      background: #F2F2F2;
      border-radius: 0;
    }
  }

  .ant-collapse-item:last-child {
    border-radius: 0;

    .ant-collapse-header {
      border-radius: 0;
    }
  }
  .ant-collapse-content-active{
      border-bottom: 1px solid #D2D2D2!important;
      border-top: 1px solid #D2D2D2!important;
  }
  /* .ant-collapse-content{
    .ant-collapse-content-box{
      background-color: #f2f2f2;
      box-shadow: 0px 0px 5px 0px rgba(52, 52, 52, 0.3);
      border-bottom: ${({ isShowChild }) => (isShowChild ? '1px solid #D2D2D2!important' : '')};
      border-top: ${({ isShowChild }) => (isShowChild ? '1px solid #D2D2D2!important' : '')};
    }
  } */
  .ant-collapse-content{
    border:0;
  }
`;

export const SalonCover = styled.ul`
  margin: 0 20px;
  > li {
    // font-family: HiraginoUDSansStd-W3;
    font-size: 14px;
    letter-spacing: 1px;
    color: #000;
    list-style-type: none;
    margin-bottom: 19px;
    margin-top: 19px;
  }
  &:not(:last-child) {
    border-bottom: 1px solid #d2d2d2;
  }
`;

export const SalonCoverTitle = styled.li`
  font-weight: bold;
`;

export const SalonCoverItem = styled.li``;

export const SalonCoverLink = styled.a`
  text-decoration: underline;
`;



// WEBPACK FOOTER //
// ./src/pages/SalonListGrooming/Accordion.style.js